export default {
  title01: "現在の天気",
  title02: "24時間",
  title03: "10日間の天気予報を見る",
  title04: "空気質指数 (AQI)",
  title05: "すべての情報を見る",
  title06: "日の出と日の入り",
  title07: "月の位相",
  title08: "次の満月",
  title09: "次の新月",
  title10: "昼",
  title11: "夜",
  title12: "日の出",
  title13: "日の入り",
  title14: "月の出",
  title15: "月の入り",
  title16: "ソース",
  title17: "開始",
  title18: "終了",
  title19: "現在地を使用",
  title20: "都市を検索",
  title21: "体感温度",
  title22: "日陰の体感温度",
  title23: "現在",
  title24: "今日",
  title25: "日",
  title26: "月",
  title27: "火",
  title28: "水",
  title29: "木",
  title30: "金",
  title31: "土",
  title32: "読み込み中...",
  title33: "現在",
  title34: "時間ごと",
  title35: "日ごと",
  title36: "太陽と月",
  title37: "空気質",
  title38: "連絡先: xlf550402@gmail.com",
  title39: "プライバシー契約",
  title40: "著作権 © comfortweather.com 2020 - 2025. 無断転載を禁じます。",
  title41: "",
  title42: "高",
  title43: "低",
  title44: "同意する",
  title45: "ComfortWeatherをご利用いただきありがとうございます！ ご自身の法的権利と利益を守るために、ご利用前に ",
  title46: "プライバシーポリシー",
  title47: " をよくお読みください。 ",
  title48: "提供のデータ",
  title49: "連絡先: xyjph123@gmail.com",
  title50: "著作権 © 24hweather.com 2020 - 2025. 無断転載を禁じます。",
  title51: "24hweatherをご利用いただきありがとうございます！ ご自身の法的権利と利益を守るために、ご利用前に ",
};
